import {
    updateOnboardingStep,
    getUser,
    changeEmail,
    changeEmailConfirm,
    updateDescription,
    updateAccount,
    getTelegramBindLink,
} from './agent';

import type { ChangeEmailConfirmRequest, IUserDescription, StepsType } from 'src/types/User';

class UserService {
    queryKey = 'user';

    updateOnboardingStep = async (step: StepsType) => {
        try {
            console.log(`📤 [UserService] Отправляем запрос на обновление шага: ${step} (тип: ${typeof step})`);
            const { data } = await updateOnboardingStep(step);
            console.log(`✅ [UserService] Получен ответ:`, data);
            return Promise.resolve(data);
        } catch (error: any) {
            console.error(`❌ [UserService] Ошибка обновления шага:`, error);
            console.error(`❌ [UserService] Детали ошибки:`, {
                status: error?.response?.status,
                statusText: error?.response?.statusText,
                data: error?.response?.data,
                message: error?.message,
                requestData: { step },
            });
            return Promise.reject(error);
        }
    };

    getUser = async () => {
        try {
            const { data } = await getUser();

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    changeEmail = async (data: Pick<ChangeEmailConfirmRequest, 'new_email'>) => {
        try {
            await changeEmail(data);

            return Promise.resolve({});
        } catch (error) {
            return Promise.reject(error);
        }
    };

    changeEmailConfirm = async (data: ChangeEmailConfirmRequest) => {
        try {
            await changeEmailConfirm(data);

            return Promise.resolve({});
        } catch (error) {
            return Promise.reject(error);
        }
    };

    updateDescription = async (formData: IUserDescription) => {
        try {
            const { data } = await updateDescription(formData);

            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    updateAccount = async (data: any) => {
        try {
            const { data: res } = await updateAccount(data);
            return Promise.resolve(res);
        } catch (error) {
            return Promise.reject(error);
        }
    };

    getTelegramBindLink = async () => {
        try {
            const { data } = await getTelegramBindLink();
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    };
}

export default new UserService();
